import { IS_SERVER } from '@app/core-features/env/env-shared';

export const scrollToTop = (behavior: ScrollBehavior = 'smooth') => {
    if (!IS_SERVER) {
        window.scrollTo({ behavior, top: 0 });
    }
};
